export default {
    topics: [
        {
            title: ' CreateFDASchema ',
            href: 'sm-extAccount-CreateFDASchema.html',
            attributes: { 'data-id': 'sm-extAccount-CreateFDASchema' },
            menu: { hasChildren: false },
            tocID: 'sm-extAccount-CreateFDASchema-d66e2884',
            topics: [],
        },
        {
            title: ' DeclareTableSpaces ',
            href: 'sm-extAccount-DeclareTableSpaces.html',
            attributes: { 'data-id': 'sm-extAccount-DeclareTableSpaces' },
            menu: { hasChildren: false },
            tocID: 'sm-extAccount-DeclareTableSpaces-d66e2892',
            topics: [],
        },
        {
            title: ' DeploySQLFunctions ',
            href: 'sm-extAccount-DeploySQLFunctions.html',
            attributes: { 'data-id': 'sm-extAccount-DeploySQLFunctions' },
            menu: { hasChildren: false },
            tocID: 'sm-extAccount-DeploySQLFunctions-d66e2900',
            topics: [],
        },
        {
            title: ' TestAccount ',
            href: 'sm-extAccount-TestAccount.html',
            attributes: { 'data-id': 'sm-extAccount-TestAccount' },
            menu: { hasChildren: false },
            tocID: 'sm-extAccount-TestAccount-d66e2908',
            topics: [],
        },
    ],
};

